import address from 'translations/fr/components/address'
import attachments from 'translations/fr/components/attachments'
import billingDetails from 'translations/fr/components/billingDetails'
import comments from 'translations/fr/components/comments'
import hooks from 'translations/fr/components/hooks'
import notification from 'translations/fr/components/notification'
import payCodes from 'translations/fr/components/payCodes'
import recurrenceRule from 'translations/fr/components/recurrenceRule'
import topBar from 'translations/fr/components/topBar'
import feedback from 'translations/fr/components/feedback'
import versions from 'translations/fr/components/versions'
import scheduleIssues from 'translations/fr/components/scheduleIssues'
import employeeRequestsSummary from 'translations/fr/components/employeeRequestsSummary'
import employeeTimeOffRequests from 'translations/fr/components/employeeTimeOffRequests'

export default {
  address,
  attachments,
  billingDetails,
  comments,
  feedback,
  hooks,
  notification,
  payCodes,
  recurrenceRule,
  topBar,
  versions,
  scheduleIssues,
  employeeRequestsSummary,
  employeeTimeOffRequests,
  ACTIONS: `Actions`,
  USER_DELETED: `Utilisateur supprimé`,
  USER_UNASSIGNED: `Non-assigné`,
  ATTRIBUTE_DELETED: `Attribut supprimé`,
  RANK_DELETED: `Niveau supprimé`,
  HIRING_DATA_DELETED: `Donnée d'embauche supprimée`,
  PROJECT_DELETED: `Projet supprimé`,
  POSITION_DELETED: `Position supprimée`,
  REQUEST_TYPE_DELETED: `Type de requête supprimée`,
  PROCEDURE_DELETED: `Procédure supprimée`,
  PUNCH_RULE_DELETED: `Règle de carte de temps supprimée`,
  SORT_DELETED: `Classement supprimé`,
  CONFIG_DELETED: `Configuration supprimée`,
  FILTER_DELETED: `Filtre supprimé`,
  TAG_DELETED: `Étiquette supprimée`,
  BREAK_DELETED: `Pause supprimée`,
  WAGE_PREMIUM_DELETED: `Prime salariale supprimée`,
  OVERTIME: `Temps supplémentaire`,
  REGULAR: `Temps régulier`,
  TEAM_DELETED: `Équipe supprimée`,
  PERMISSION_DELETED: `Permission supprimée`,
  DEPARTMENT_DELETED: `Département supprimé`,
  SCHEDULE_TEMPLATE_DELETED: `Modèle d'horaire supprimé`,
  STAFF_WARNING: `Vous êtes sur le système d'un client, soyez prudents`,
  MISSING_PERMISSIONS: `Vous n'avez pas les permissions pour voir ces informations`,
  NO_ADDRESS: `Aucune adresse`,
  NO_HIRING_DATA: `Aucune donnée d'embauche`,
  NO_SPECIFIC_RESTRICTIONS: `Aucune restriction spécifique`,
  NO_DATES: `Aucune date`,
  NO_SORT: `Aucun classement`,
  NO_FILTER: `Aucun filtre`,
  NO_CONFIG: `Aucune configuration`,
  NO_PROCEDURE: `Aucune procédure`,
  DATES_FILTER: `Date actuellement sélectionnée : {{start}} à {{end}}`,
  CLICK_TO_ADD_DATE_FILTER: `Cliquer pour sélectionner des dates spécifiques.`,
  CREATED_AT: `Crée le`,
  UPDATED_AT: `Mis à jour le`,
  APPROVED_AT: `Approuvé le`,
  noResults: {
    NO_RESULTS_FOUND: `Aucun résultat trouvé`,
    CHANGE_FILTER: `Essayez de changer les filtres`,
    CHANGE_VIEW: `Activez 'Rangées vides' pour voir toutes les rangées`
  },
  filtersChange: {
    FILTERS_HAVE_CHANGED: `Les filtres ont changé`,
    SEARCH_LINK: `Cliquez ici pour appliquer les nouveaux filtres`
  },

  RADIO: {
    LABEL: ``,
    OPTIONS: {
      YES: {
        LABEL: `Oui`,
        DESCRIPTION: ``
      },
      NO: {
        LABEL: `Non`,
        DESCRIPTION: ``
      }
    }
  },
  table: {
    MINUTES: `minutes`,
    HOURS: `heures`,
    DAYS: `jours`,
    WEEKS: `semaines`,
    TENTATIVES: `tentatives`,
    NOTHING_TO_DISPLAY: `Aucune ressource à afficher`,
    NOTHING_ON_THIS_PAGE: `Aucune ressource sur cette page`,
    LOADING_ITEMS: `Chargement des ressources en cours`,
    TOOLS: 'Outils',
    EXPORT_AS_CSV: `Exporter en CSV`,
    EXPORT_AS_PDF: `Exporter en PDF`,
    HIDE_ARCHIVED: `Cacher les ressources archivées`,
    LOAD_ARCHIVED: `Afficher les ressources archivées`,
    EXPORT: `Exports`,
    SYNC: `Synchroniser`,
    FILTERS_HAVE_CHANGED: `Les filtres ont changé`,
    SEARCH_LINK: `Cliquez ici pour appliquer les nouveaux filtres`
  },
  PROGRESS_MODAL: {
    TITLE: `Progression`,
    SUMMARY: `Veuillez patienter pendant que les modifications sont appliquées.`
  },
  sync: {
    TITLE: `Synchronisation des ressources`,
    SUMMARY: ``,
    JOB_PICKED_UP: `Démarrage de la synchronisation`,
    FETCHING_TAGS: `Obtention des informations des tags`,
    PARSING_DATA: `Analyse des modifications à apporter.`,
    COMPUTING_DIFFS: `Calcul des modifications à apporter.`,
    CREATING_NEW_TAGS: `Création des nouveaux tags`,
    UPDATING_TAGS: `Modification des tags existants`,
    FETCHING_PROJECTS: `Obtention des informations concernant les projets`,
    CREATING_NEW_PROJECTS: `Création des nouveaux projets`,
    UPDATING_PROJECTS: `Modification des projets actuels`,
    SYNC_RESULTS: `Résultats de la synchronisation`,
    REFRESH: `Actualiser`,
    CREATED: `{{toCreate}} créé`,
    UPDATED: `{{toUpdate}} modifié`
  },
  dayOfWeek: {
    0: `Dimanche :`,
    1: `Lundi :`,
    2: `Mardi :`,
    3: `Mercredi :`,
    4: `Jeudi :`,
    5: `Vendredi :`,
    6: `Samedi :`
  },
  dayOfWeekNoColon: {
    0: `Dimanche`,
    1: `Lundi`,
    2: `Mardi`,
    3: `Mercredi`,
    4: `Jeudi`,
    5: `Vendredi`,
    6: `Samedi`
  },
  availabilities: {
    AVAILABLE_ALL_DAY: `Disponible`,
    NOT_AVAILABLE: `Indisponible`,
    NOT_AVAILABLE_ALL_DAY: `Indisponible`,
    PREFER_TEXT: `Préfère`,
    UNAVAILABLE_TEXT: `Indisponible`,
    AVAILABLE_TEXT: `Disponible`,
    SHOW_CHANGES: `Afficher les changements`,
    HIDE_CHANGES: `Cacher les changements`,
    FROM_TIME: `de`,
    TO_TIME: ` à `
  },
  sort: {
    REQUESTDATE: `Date de création`,
    CREATIONDATE: `Date de création`,
    START: `Début`,
    END: `Fin`,
    VALIDATEDATE: `Date de validation`,
    LASTUPDATEDATE: `Date de modification`,
    VALIDITY: `Date de validité`
  },
  importFieldCode: {
    MISSING_CODES: `Si la ressource que vous cherchez n'est pas affichée, veuillez ajouter un code d'importation à celle-ci.`,
    EDIT_RESOURCES: `Modifier les ressources`,
    SHOW_IMPORT_CODE: `(Montrer les codes d'importation)`,
    IMPORT_CODES: `Codes d'import (cliquer pour voir)`
  },
  addResource: {
    NO_RESOURCES: `Il n'y a aucune ressource disponible.`,
    ADD_RESOURCES: `Ajouter des ressources ici.`,
    NO_PERMISSION: `Veuillez contacter votre administrateur pour ajouter des ressources.`
  },
  resetPassword: {
    RESET_PASSWORD_MODAL: {
      TITLE: `Réinitialisation de ton mot de passe`,
      SUMMARY: ``
    }
  },
  END_TIME_BEFORE_START_TIME: `L'heure de fin doit être après l'heure de début.`,
  END_DATE_BEFORE_START_DATE: `La date de fin doit être après la date de début.`,
  NOTHING_TO_DISPLAY: `Rien à afficher`,
  VIEW_LESS: `Voir moins`,
  VIEW_MORE: `Voir plus`
}
